import { computed } from 'vue';
import { useClaims } from '@auth/useClaims';
import { Relatietype } from './types';

/**
 * Het relatietype waarmee een nieuw relatieformulier begint, afgeleid van het actieve marktsegment.
 *
 * Marktsegment en relatietype zijn twee losse kenmerken: binnen Zakelijk zijn beide relatietypen
 * bruikbaar, binnen Particulier alleen het particuliere type.
 *
 * `isSuccess` telt mee omdat `isParticulier` false is zolang de claims nog laden. Zonder die
 * controle begint een particuliere gebruiker met een zakelijk formulier dat daarna omklapt.
 */
export function useRelatietypeVoorMarktsegment() {
  const claims = useClaims();

  const isParticulierMarktsegment = computed(
    () => claims.value.isSuccess && claims.value.isParticulier,
  );

  return {
    isParticulierMarktsegment,
    claimsGeladen: computed(() => claims.value.isSuccess),
    relatietype: computed(() => (isParticulierMarktsegment.value ? Relatietype.P : Relatietype.Z)),
  };
}
